type KEY = "ACCESS_TOKEN" | "REFRESH_TOKEN" | "USER" | "HL_SELECTED_COMPANY_ID" | "SELECTED_AGREEMENT" | "SHOW_SUBSCRIPTION_MODAL";

export class LocalStorage {
    static setItem(key: KEY, value: any) {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static getItem(key: KEY)  {
        const data = localStorage.getItem(key);
        if(data) {
            return JSON.parse(data);
        }
        return null
    }
    static removeItem(key: KEY) {
        localStorage.removeItem(key);
    }
}